/**
 * Names of action creators
 */ export var ActionCreator = /*#__PURE__*/ function(ActionCreator) {
    ActionCreator["Activity"] = "activity";
    ActionCreator["AppContext"] = "appContext";
    ActionCreator["Bucket"] = "bucket";
    ActionCreator["CacheDataFetch"] = "cacheDataFetch";
    ActionCreator["Campaign"] = "campaign";
    ActionCreator["Capabilities"] = "capabilities";
    ActionCreator["Copilot"] = "copilot";
    ActionCreator["CustomFieldDefinition"] = "customFieldDefinition";
    ActionCreator["Centro"] = "centro";
    ActionCreator["Chat"] = "chat";
    ActionCreator["ChildView"] = "childView";
    ActionCreator["CopyPlanView"] = "copyPlanView";
    ActionCreator["Container"] = "container";
    ActionCreator["CreatePlanView"] = "createPlanView";
    ActionCreator["CreatePortfolioView"] = "createPortfolioView";
    ActionCreator["CreateTaskFromTeamsMessage"] = "createTaskFromTeamsMessage";
    ActionCreator["CreateTaskView"] = "createTaskView";
    ActionCreator["CreateTeamsTabView"] = "createTeamsTabView";
    ActionCreator["DataIntegrity"] = "dataIntegrity";
    ActionCreator["DataPreFetch"] = "dataPreFetch";
    ActionCreator["Dependency"] = "dependency";
    ActionCreator["DriveItem"] = "driveItem";
    ActionCreator["DynamicFilter"] = "dynamicFilter";
    ActionCreator["Export"] = "export";
    ActionCreator["Goal"] = "goal";
    ActionCreator["GroundingResource"] = "groundingResource";
    ActionCreator["History"] = "history";
    ActionCreator["Intelligence"] = "intelligence";
    ActionCreator["KeyboardHandlers"] = "keyboardHandlers";
    ActionCreator["LeftNavView"] = "leftNavView";
    ActionCreator["Links"] = "links";
    ActionCreator["Modal"] = "modal";
    ActionCreator["ModernGroup"] = "modernGroup";
    ActionCreator["ModernGroupConversation"] = "modernGroupConversation";
    ActionCreator["Mru"] = "mru";
    ActionCreator["MyDayView"] = "myDayView";
    ActionCreator["MyPlansView"] = "myPlansView";
    ActionCreator["MyPortfoliosView"] = "myPortfoliosView";
    ActionCreator["MyTasksView"] = "myTasksView";
    ActionCreator["NewsBar"] = "newsBar";
    ActionCreator["Notification"] = "notification";
    ActionCreator["OCV"] = "OCV";
    ActionCreator["OperationTracking"] = "operationTracking";
    ActionCreator["Org"] = "org";
    ActionCreator["PerformanceCollection"] = "performanceCollection";
    ActionCreator["PinnedTasks"] = "pinnedTasks";
    ActionCreator["Plan"] = "plan";
    ActionCreator["PlanCalendarNudge"] = "planCalendarNudge";
    ActionCreator["PlanConversion"] = "planConversion";
    ActionCreator["PlanView"] = "planView";
    ActionCreator["Portfolio"] = "portfolio";
    ActionCreator["PremiumPlan"] = "premiumPlan";
    ActionCreator["RecommendedPlans"] = "recommendedPlans";
    ActionCreator["Roster"] = "roster";
    ActionCreator["Routing"] = "routing";
    ActionCreator["Scheduling"] = "scheduling";
    ActionCreator["SharePlanView"] = "sharePlanView";
    ActionCreator["StatusReport"] = "statusReport";
    ActionCreator["SuiteNav"] = "suiteNav";
    ActionCreator["SuiteNavView"] = "suiteNavView";
    ActionCreator["Task"] = "task";
    ActionCreator["TaskEditorView"] = "taskEditorView";
    ActionCreator["TaskOrder"] = "taskOrder";
    ActionCreator["Teams"] = "teams";
    ActionCreator["TeamsTab"] = "teamsTab";
    ActionCreator["Template"] = "template";
    ActionCreator["Tenant"] = "tenant";
    ActionCreator["Upsell"] = "upsell";
    ActionCreator["User"] = "user";
    ActionCreator["ViewLifecycle"] = "viewLifecycle";
    ActionCreator["ViewTransforms"] = "viewTransforms";
    return ActionCreator;
}({});
